import { getMemberDisplayName } from '../members/types';

export interface TranscriptMetadata {
  transcriptIds: string[];
  transcriptDates: string[];
  transcriptNames?: string[];
  subjectId: string;
  subjectName?: string;
  documentCount: number;
}

type BreadcrumbTeamMember = {
  person: {
    id: string;
    primary_email: string;
    given_name?: string;
    family_name?: string;
  };
};

export const resolveSubjectNameForBreadcrumb = ({
  subjectId,
  subjectName,
  teamMembers,
}: {
  subjectId?: string | null;
  subjectName?: string | null;
  teamMembers?: BreadcrumbTeamMember[] | null;
}): string | null => {
  const explicitName = subjectName?.trim();
  if (explicitName) {
    return explicitName;
  }
  if (!subjectId || !teamMembers || teamMembers.length === 0) {
    return null;
  }
  const member = teamMembers.find((candidate) => candidate.person.id === subjectId);
  if (!member) {
    return null;
  }
  return getMemberDisplayName(member);
};

export function parseTranscriptMetadataParams(
  searchParams: URLSearchParams
): TranscriptMetadata | null {
  const transcriptIdsParam = searchParams.get('transcript_ids');
  const transcriptDatesParam = searchParams.get('transcript_dates');
  const transcriptNamesParam = searchParams.get('transcript_names');
  const subjectIdParam = searchParams.get('subject_id');
  const subjectNameParam = searchParams.get('subject_name');

  if (!transcriptIdsParam || !transcriptDatesParam || !subjectIdParam) {
    return null;
  }

  const transcriptIds = transcriptIdsParam.split(',').filter(Boolean);
  const transcriptDates = transcriptDatesParam.split(',').filter(Boolean);

  let transcriptNames: string[] | null = null;
  if (transcriptNamesParam) {
    try {
      const parsed = JSON.parse(transcriptNamesParam);
      if (Array.isArray(parsed)) {
        transcriptNames = parsed.map((name) => (typeof name === 'string' ? name.trim() : ''));
      }
    } catch {
      transcriptNames = null;
    }
  }

  if (transcriptIds.length !== transcriptDates.length || transcriptIds.length === 0) {
    return null;
  }

  if (transcriptNames && transcriptNames.length !== transcriptIds.length) {
    transcriptNames = null;
  }

  return {
    transcriptIds,
    transcriptDates,
    transcriptNames: transcriptNames || undefined,
    subjectId: subjectIdParam,
    subjectName: subjectNameParam?.trim() || undefined,
    documentCount: transcriptIds.length,
  };
}
